import React, {useState} from 'react';
import {AppLayoutProps} from "@sendbird/uikit-react/types/modules/App/types";
import {useSendbirdStateContext} from '@sendbird/uikit-react';
import {SendableMessageType} from "@sendbird/uikit-react/types/utils";
import {DesktopLayout} from "./ChatDesktopLayout";

export const ChatLayout: React.FC<AppLayoutProps> = (
  props: AppLayoutProps,
) => {
  const {
    isMessageGroupingEnabled,
    allowProfileEdit,
    onProfileEditSuccess,
    disableAutoSelect,
    currentChannel,
    setCurrentChannel,
    enableLegacyChannelModules,
  } = props;

  const globalStore = useSendbirdStateContext();
  const globalConfigs = globalStore?.config;

  const [showThread, setShowThread] = useState(false);
  const [threadTargetMessage, setThreadTargetMessage] = useState<SendableMessageType | null>(null);
  const [showSettings, setShowSettings] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [highlightedMessage, setHighlightedMessage] = useState<number | null>(null);
  const [startingPoint, setStartingPoint] = useState<number | null>(null);

  /**
   * Below configs can be set via Dashboard UIKit config setting but as a lower priority than App props.
   * So need to be have fallback value \w global configs even though each prop values are undefined
   */
  const replyType = props.replyType ?? globalConfigs?.replyType;
  const isReactionEnabled = props.isReactionEnabled ?? globalConfigs?.isReactionEnabled;
  const showSearchIcon = props.showSearchIcon ?? globalConfigs?.showSearchIcon;

  return (
    <>
      <DesktopLayout
        replyType={replyType}
        isReactionEnabled={isReactionEnabled}
        showSearchIcon={showSearchIcon}
        isMessageGroupingEnabled={isMessageGroupingEnabled}
        allowProfileEdit={allowProfileEdit}
        onProfileEditSuccess={onProfileEditSuccess}
        disableAutoSelect={disableAutoSelect}
        currentChannel={currentChannel}
        setCurrentChannel={setCurrentChannel}
        showThread={showThread}
        setShowThread={setShowThread}
        threadTargetMessage={threadTargetMessage}
        setThreadTargetMessage={setThreadTargetMessage}
        showSettings={showSettings}
        setShowSettings={setShowSettings}
        showSearch={showSearch}
        setShowSearch={setShowSearch}
        highlightedMessage={highlightedMessage}
        setHighlightedMessage={setHighlightedMessage}
        startingPoint={startingPoint}
        setStartingPoint={setStartingPoint}
        enableLegacyChannelModules={enableLegacyChannelModules}
      />
    </>
  );
};
